/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { KTSVG } from "../../../helpers";
import { AsideMenuItemWithSub } from "./AsideMenuItemWithSub";
import { AsideMenuItem } from "./AsideMenuItem";
import { useSelector, shallowEqual } from "react-redux";
import { RootState } from "../../../../setup/redux/RootReducer";

// custom hook
import { useOnlyAccessPermissionForHanayAdmin } from "../../../../app/hooks/useOnlyAccessPermissionForHanayAdmin";
import { useUserRole } from "../../../../app/hooks/useUserRole";

// custom hook
import { useAppPermission } from "../../../../app/hooks/useAppPermission";

export function AsideMenuMain() {
  const intl = useIntl();

  const [isHanayAdmin] = useOnlyAccessPermissionForHanayAdmin();
  const [superAdmin, hanayUser, aggregatorUser] = useUserRole();
  const [permissions] = useAppPermission();

  const isShowForHanayAdmin = superAdmin || hanayUser;
  const isShowForAggregatorAdmin = aggregatorUser;
  //console.log(userData.data.role.id);

  // permission check start

  const isViewEmployee = [
    "employee__POST__registration",
    "employee__POST__onboard-aggregator-employee",
    "employee__POST__list",
  ].some((item: string) => permissions.includes(item));

  const Rb_AgFarmer = permissions.includes(
    "reserve-bunch__POST__aggregator-farmer-reserve-list"
  );
  const Rb_MyFarmer = permissions.includes(
    "reserve-bunch__POST__my-farmer-reserve-list"
  );

  const isViewCustomerListMenu = [
    "customer__POST__add",
    "customer__POST__list",
  ].some((item: string) => permissions.includes(item));

  const isViewOrderListMenu = ["order__POST__add", "order__POST__list"].some(
    (item: string) => permissions.includes(item)
  );

  const isViewStockDetailsMenu = [
    "stock-tran__POST__add",
    "stock-tran__POST__chamber-wise-stock",
  ].some((item: string) => permissions.includes(item));

  const isViewStockVaritysMenu = [
    "stock-tran__POST__variant-wise-stock",
    "stock-tran__POST__add",
  ].some((item: string) => permissions.includes(item));

  const isViewTrainingMaterial = [
    "training-material__POST__add",
    "training-material__POST__list",
  ].some((item: string) => permissions.includes(item));

  const isViewHelpLine = ["help-line__POST__list", "help-line__POST__add"].some(
    (item: string) => permissions.includes(item)
  );

  const isViewBananaType = [
    "crop-variety__POST__add",
    "crop-variety__POST__list",
  ].some((item: string) => permissions.includes(item));

  const isViewCustomerType = [
    "customer-type__POST__add",
    "customer-type__POST__list",
  ].some((item: string) => permissions.includes(item));

  const isViewChamber = ["chamber__POST__add", "chamber__POST__list"].some(
    (item: string) => permissions.includes(item)
  );

  const isViewDesignation = [
    "designation__POST__add",
    "designation__POST__list",
  ].some((item: string) => permissions.includes(item));

  const isViewDamageType = [
    "damage-type__POST__list",
    "damage-type__POST__add",
  ].some((item: string) => permissions.includes(item));

  const ispViewCultivationType = [
    "cultivation-type__POST__add",
    "cultivation-type__POST__list",
  ].some((item: string) => permissions.includes(item));

  const isViewPesticide = [
    "pesticide__POST__list",
    "pesticide__POST__add",
  ].some((item: string) => permissions.includes(item));

  const isViewRoleManageMent = ["role__GET__list", "role__POST__add"].some(
    (item: string) => permissions.includes(item)
  );

  const isViewSupplyBananaType = [
    "supply-banana-type__POST__add",
    "supply-banana-type__POST__list",
  ].some((item: string) => permissions.includes(item));

  // permission check end

  return (
    <>
      <div style={{ marginBottom: "60px" }}>
        {" "}
        {/*  start dashboard  */}
        <AsideMenuItem
          to="/dashboard"
          icon="/media/icons/duotune/sidebarIcon/deshboard.svg"
          title={intl.formatMessage({ id: "MENU.DASHBOARD" })}
          fontIcon="bi-app-indicator"
        />
        {/*  end dashboard  */}
        {/* <------------> */}
        {/* start Employee  */}
        {isViewEmployee && (
          <AsideMenuItem
            to="/employee"
            icon="/media/icons/duotune/sidebarIcon/user.svg"
            title="Employee"
            fontIcon="bi-layers"
          />
        )}
        {/* end Employee  */}
        {/* <------------> */}
        {/* start banana calender  */}
        {(Rb_AgFarmer || Rb_MyFarmer) && (
          <AsideMenuItemWithSub
            to=""
            title="Reserve Bunch"
            fontIcon="bi-chat-left"
            icon="/media/icons/duotune/sidebarIcon/Calendar.svg"
          >
            {isShowForHanayAdmin && Rb_MyFarmer && (
              <AsideMenuItem
                to="/reserve-bunch/my-farmers"
                title="My Farmers"
                hasBullet={true}
              />
            )}
            {Rb_AgFarmer && (
              <AsideMenuItem
                to="/reserve-bunch/aggregators-farmers"
                title={aggregatorUser ? "My Farmer" : "Aggregator Farmers"}
                hasBullet={true}
              />
            )}
          </AsideMenuItemWithSub>
        )}
        {/* end banana calender  */}
        {/* <------------> */}
        {/* start supplier */}
        <AsideMenuItemWithSub
          to=""
          title="Supplier"
          fontIcon="bi-chat-left"
          icon="/media/icons/duotune/sidebarIcon/SaleSquare.svg"
        >
          <AsideMenuItem
            to="/supplier/pending-farmers"
            title="Pending Farmers"
            hasBullet={true}
          />
          {isShowForHanayAdmin && (
            <>
              <AsideMenuItem
                to="/supplier/my-farmers"
                title="My Farmers"
                hasBullet={true}
              />

              <AsideMenuItem
                to="/supplier/my-aggregators"
                title="My Aggregators"
                hasBullet={true}
              />
            </>
          )}
          <AsideMenuItem
            to="/supplier/aggregators-farmers"
            title="Aggregators Farmers"
            hasBullet={true}
          />
        </AsideMenuItemWithSub>
        {/* end supplier */}
        {/* <------------> */}
        {/* start customer */}
        {isShowForHanayAdmin &&
          (isViewCustomerListMenu || isViewOrderListMenu) && (
            <AsideMenuItemWithSub
              to=""
              title="Customer"
              fontIcon="bi-chat-left"
              icon="/media/icons/duotune/sidebarIcon/user.svg"
            >
              {isViewCustomerListMenu && (
                <AsideMenuItem
                  to="/customer/customer-list"
                  title="Customer list"
                  hasBullet={true}
                />
              )}
              {isViewOrderListMenu && (
                <AsideMenuItem
                  to="/customer/order"
                  title="Order List"
                  hasBullet={true}
                />
              )}
            </AsideMenuItemWithSub>
          )}
        {/* end customer */}
        {/* <------------> */}
        {/* start inventory */}
        {isShowForHanayAdmin &&
          (isViewStockDetailsMenu || isViewStockVaritysMenu) && (
            <AsideMenuItemWithSub
              to=""
              title="Inventory"
              fontIcon="bi-chat-left"
              icon="/media/icons/duotune/sidebarIcon/Graph.svg"
            >
              {
                <AsideMenuItem
                  to="inventory/stock"
                  title="Stock"
                  hasBullet={true}
                />
              }

              {/* { isViewStockDetailsMenu && <AsideMenuItem
              to="inventory/stock-chamber"
              title="Stock by Chamber"
              hasBullet={true}
            /> } */}

              {isViewStockVaritysMenu && (
                <AsideMenuItem
                  to="inventory/stock-variety"
                  title="Stock By Variety"
                  hasBullet={true}
                />
              )}

              {
                <AsideMenuItem
                  to="inventory/stock-grading"
                  title="Stock By Grading"
                  hasBullet={true}
                />
              }

              {
                <AsideMenuItem
                  to="inventory/stock-approval"
                  title="Stock Approval"
                  hasBullet={true}
                />
              }
            </AsideMenuItemWithSub>
          )}
        {/* end inventory */}
        {/* <------------> */}
        {/*  report   start   */}
        <AsideMenuItemWithSub
          to=""
          title="Report"
          fontIcon="bi-chat-left"
          icon="/media/icons/duotune/sidebarIcon/Graph.svg"
        >
          {
            <AsideMenuItem
              to="report/day-wise-sells-report"
              title="Day Wise Report"
              hasBullet={true}
            />
          }

          {
            <AsideMenuItem
              to="report/day-wise-wastage-report"
              title="Day Wise Wastage Report"
              hasBullet={true}
            />
          }

          {
            <AsideMenuItem
              to="report/enterprise-wise-return-report"
              title="Enterprise Wise Return Report"
              hasBullet={true}
            />
          }

          {
            <AsideMenuItem
              to="report/enterprise-wise-sales-report"
              title="Enterprise Wise Sales Report"
              hasBullet={true}
            />
          }
        </AsideMenuItemWithSub>
        {/*  report   end   */}
        {/* <------------> */}
        {/* start reports */}
        {/* {isShowForHanayAdmin && (
          <AsideMenuItemWithSub
            to=""
            title="Reports"
            fontIcon="bi-chat-left"
            icon="/media/icons/duotune/sidebarIcon/Chart.svg"
          >
            <AsideMenuItem
              to="#"
              title="Analytics Reporting"
              hasBullet={true}
            />

            <AsideMenuItem to="#" title="Demand Forecast" hasBullet={true} />

            <AsideMenuItem to="#" title="Sales Plans" hasBullet={true} />
          </AsideMenuItemWithSub>
        )} */}
        {/* end reports */}
        {/* <------------> */}
        {/* start training material */}
        {isViewTrainingMaterial && (
          <AsideMenuItem
            to="/training-material"
            icon="/media/icons/duotune/sidebarIcon/user.svg"
            title="Training Material"
            fontIcon="bi-layers"
          />
        )}
        {/* end training material */}
        {/* <------------> */}
        {/* start help line */}
        {isViewHelpLine && (
          <AsideMenuItem
            to="/help-line"
            icon="/media/icons/duotune/sidebarIcon/user.svg"
            title="Help Line"
            fontIcon="bi-layers"
          />
        )}
        {/* end help line */}
        {/* <------------> */}
        {/* start setting */}
        {isShowForHanayAdmin && (
          <AsideMenuItemWithSub
            to="#"
            title="Settings"
            fontIcon="bi-chat-left"
            icon="/media/icons/duotune/sidebarIcon/Setting.svg"
          >
            {superAdmin && (
              <AsideMenuItem
                to="/settings/access-permission"
                title="Access Permission"
                hasBullet={true}
              />
            )}

            {isViewBananaType && (
              <AsideMenuItem
                to="/settings/banana-types"
                title="Banana Types"
                hasBullet={true}
              />
            )}

            {isViewCustomerType && (
              <AsideMenuItem
                to="/settings/customer-type"
                title="Customer Type"
                hasBullet={true}
              />
            )}

            {isViewChamber && (
              <AsideMenuItem
                to="/settings/chamber"
                title="Chamber"
                hasBullet={true}
              />
            )}

            {isViewDesignation && (
              <AsideMenuItem
                to="/settings/designation"
                title="Designation"
                hasBullet={true}
              />
            )}

            {isViewDamageType && (
              <AsideMenuItem
                to="/settings/damage-type"
                title="Damage Type"
                hasBullet={true}
              />
            )}

            {/* <AsideMenuItem
            to="/settings/district"
            title="District"
            hasBullet={true}
          /> */}

            {ispViewCultivationType && (
              <AsideMenuItem
                to="/settings/land-preparation"
                title="Cultivation Practice"
                hasBullet={true}
              />
            )}

            {superAdmin && (
              <AsideMenuItem
                to="/settings/module"
                title="Module"
                hasBullet={true}
              />
            )}

            {isViewPesticide && (
              <AsideMenuItem
                to="/settings/pesticide"
                title="Pesticide"
                hasBullet={true}
              />
            )}

            <AsideMenuItem
              to="/settings/fertilizer"
              title="Fertilizer"
              hasBullet={true}
            />

            {isViewRoleManageMent && (
              <AsideMenuItem
                to="/settings/role-management"
                title="Role Management"
                hasBullet={true}
              />
            )}

            {isViewSupplyBananaType && (
              <AsideMenuItem
                to="/settings/supply-banana-type"
                title="Supply Banana Type"
                hasBullet={true}
              />
            )}
          </AsideMenuItemWithSub>
        )}
        {/* end setting */}
        <div className="menu-item">
          <div className="menu-content">
            <div className="separator mx-12 my-4"></div>
          </div>
        </div>
        {/* <AsideMenuItem to="/my-page" title="My Page" /> */}
      </div>
    </>
  );
}
